import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import axiosAuthInstance from '../../../utils/axios/axiosAuthInstance'

const View = () => {
  const { id } = useParams()
  const [team, setTeam] = useState(null)
  const [loading, setLoading] = useState(true)

  const fetchTeamData = async () => {
    try {
      const response = await axiosAuthInstance.get(`team/detail/${id}`)
      setTeam(response.data.result)
    } catch (error) {
      console.error('Error fetching team data:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchTeamData()
  }, [id])

  const getTeamLeaderName = (tlData) => {
    return tlData.map((obj) => (
      <div>{obj.full_name}</div>
    ))
  }

  if (loading) {
    return <div>Loading...</div>
  }

  if (!team) {
    return <div>No team data found.</div>
  }

  return (
    <div className='p-4'>
      <div className='bg-white text-black shadow-md rounded-lg p-6'>
        <h2 className='text-xl font-semibold mb-2'>Team Details</h2>
        <div className='overflow-x-auto'>
          <table className='table-auto w-full border-collapse'>
            <tbody>
              <tr>
                <td className='border-b px-4 py-2 font-medium'>Full Name</td>
                <td className='border-b px-4 py-2'>{team.full_name}</td>
              </tr>
              <tr>
                <td className='border-b px-4 py-2 font-medium'>Email</td>
                <td className='border-b px-4 py-2'>{team.email}</td>
              </tr>
              <tr>
                <td className='border-b px-4 py-2 font-medium'>Mobile</td>
                <td className='border-b px-4 py-2'>{team.mobile}</td>
              </tr>
              <tr>
                <td className='border-b px-4 py-2 font-medium'>Skype</td>
                <td className='border-b px-4 py-2'>{team.skype}</td>
              </tr>
              <tr>
                <td className='border-b px-4 py-2 font-medium'>Address</td>
                <td className='border-b px-4 py-2'>{team.address}</td>
              </tr>
              <tr>
                <td className='border-b px-4 py-2 font-medium'>
                  Work Experience
                </td>
                <td className='border-b px-4 py-2'>{team.work_experience}</td>
              </tr>
              <tr>
                <td className='border-b px-4 py-2 font-medium'>Team Leader</td>
                <td className='border-b px-4 py-2'>
                  {getTeamLeaderName(team?.team_leader)}
                </td>
              </tr>
              <tr>
                <td className='border-b px-4 py-2 font-medium'>
                  Candidate Role
                </td>
                <td className='border-b px-4 py-2'>
                  {team.candidate_role.name}
                </td>
              </tr>
              <tr>
                <td className='border-b px-4 py-2 font-medium'>Username</td>
                <td className='border-b px-4 py-2'>{team.username}</td>
              </tr>
              <tr>
                <td className='border-b px-4 py-2 font-medium'>Photo</td>
                <td className='border-b px-4 py-2'>
                  {team.photo ? (
                    <img
                      src={team.photo}
                      alt='Team'
                      className='my-2 w-24 h-24 sm:w-32 sm:h-32 object-contain'
                    />
                  ) : (
                    <span>No photo available</span>
                  )}
                </td>
              </tr>
              <tr>
                <td className='border-b px-4 py-2 font-medium'>ID Proof</td>
                <td className='border-b px-4 py-2'>
                  {team.id_proof ? (
                    <img
                      src={team.id_proof}
                      alt='ID Proof'
                      className='my-2 w-24 h-24 sm:w-32 sm:h-32 object-contain'
                    />
                  ) : (
                    <span>No ID proof available</span>
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default View
